import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/descuentos`, options).then(response => {
    return {
      list: response.data.data,
      meta: response.data.meta
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/descuentos/${id}`, options)
    .then(response => {
      let descuento = jsona.deserialize(response.data);
      delete descuento.links;
      return descuento;
    });
}

function add(descuento) {
  const payload = jsona.serialize({
    stuff: descuento,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/descuentos`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(descuento) {
  const payload = jsona.serialize({
    stuff: descuento,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .patch(`${url}/descuentos/${descuento.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function activate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/descuentos/activate/${id}`, options);
}

function deactivate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/descuentos/deactivate/${id}`, options);
}

function listActive(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.get(`${url}/descuentos/listActive`+'?subcorrida_id='+id, options).then(response => {
    return {
      listActive: jsona.deserialize(response.data),
    };
  });
}

function getTotalPorCorrida(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/descuentos/obtenerTotalPorCorrida`+'?corrida_id='+data.corrida_id+'&descuento_id='+data.descuento_id, options)
    .then(response => {
      return response.data;
    });
}

export default {
  list,
  listActive,
  get,
  add,
  update,
  activate,
  deactivate,
  getTotalPorCorrida
};
